import { render, staticRenderFns } from "./PriceCard1-3.vue?vue&type=template&id=786511ec&scoped=true&"
import script from "./PriceCard1-3.vue?vue&type=script&lang=js&"
export * from "./PriceCard1-3.vue?vue&type=script&lang=js&"
import style0 from "./PriceCard1-3.vue?vue&type=style&index=0&id=786511ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786511ec",
  null
  
)

export default component.exports